import { types as actionTypes } from './waiverConfigurationsActions';
import { Action } from '../../../types';
import { WaiverConfiguration } from '../../../../types/waiver';

export interface WaiverConfigurationsState {
  loading: boolean;
  entities?: WaiverConfiguration[];
  error?: string;
}

const initialState: WaiverConfigurationsState = {
  loading: false,
};

export default function reducer(
  state: WaiverConfigurationsState = initialState,
  action: Action<WaiverConfiguration[]>,
): WaiverConfigurationsState {
  switch (action.type) {
    case actionTypes.LOAD:
      return {
        loading: true,
      };
    case actionTypes.LOAD_SUCCESS:
      return {
        loading: false,
        entities: action.response,
      };
    case actionTypes.LOAD_FAILURE:
      return {
        loading: false,
        error: action.error ? action.error.message : undefined,
      };
    default:
      return state;
  }
}
